module.exports = __webpack_public_path__ + "img/42.2932b78f.png";